import ApiConstants from '../constants/ApiConstants';
import http from "../http";
import { Subject } from 'rxjs';
export interface    NotificationAPIConfig {
    
    Limit?: number;
    CurrentPage?: number;
    Order?: string;
    Field?:string;
}

const defaultConfig: NotificationAPIConfig = {
    Limit: 20,
    CurrentPage: 0,
    Order: 'desc',
    Field: '_id'
};

class NotificationService {

    static getNotifications(pageSize) {
        const URL = ApiConstants.URL.NOTIFICATION.GET_ALL;
        const params = {
            limit: pageSize
        }

        return http.get(URL, { params: params }).catch(
            (error: any) => {
                console.error('Error loading notifications: ', error);
                return Promise.reject(error);
            }
        );
    }
    static getNotificationsAndMarkAllAsRead() {
        const payload = {
            status: 'read'
        };

        return http.patch(ApiConstants.URL.NOTIFICATION.GET_ALL, payload)            
    }
}

export default NotificationService;

const subject = new Subject();
export const NotificationsUpdate = {
    sendMessage: message => subject.next({ text: message }),
    clearMessages: () => subject.next({}),
    getMessage: () => subject.asObservable()
};